module.exports = __webpack_public_path__ + "static/img/C4D0021.e8da904.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0021.jpg
// module id = aSs7
// module chunks = 0